// import React, { useEffect, useState, useRef } from 'react';
// import { useParams, useNavigate } from 'react-router-dom';
// import { Spinner } from 'react-bootstrap';
// import axios from 'axios';
// import { BASE_URL } from '../../../services/Api';
// import { authHeader } from '../../../services/auth-header';

// const PoDomPrint = () => {
//     const { id } = useParams();
//     const navigate = useNavigate();
//     const [isLoading, setIsLoading] = useState(true);
//     const [poData, setPoData] = useState({});
//     const [uom, setUom] = useState('Nos.');
//     const printRef = useRef();

//     const PoPrintData = async () => {
//         try {
//             const response = await axios.get(`${BASE_URL}purchaseOrder/findById/${id}`, {
//                 headers: authHeader(),
//             });
//             const data = response.data;
//             setPoData(data);

//             if (data.purchaseOrderItems && data.purchaseOrderItems.length > 0) {
//                 const firstItem = data.purchaseOrderItems[0];
//                 setUom(firstItem.uom || 'Nos.');
//             }

//             console.log(response.data);
//         } catch (error) {
//             console.error("Error fetching po data", error);
//         } finally {
//             setIsLoading(false);
//         }
//     };

//     useEffect(() => {
//         PoPrintData();
//     }, [id]);

//     const handlePrint = () => {
//         const printContent = printRef.current;
//         const WinPrint = window.open('', '', 'width=900,height=650');

//         WinPrint.document.write(`
//             <html>
//                 <head>
//                     <title>Purchase Order</title>
//                     <style>
//                         body { 
//                             margin: 0; 
//                             padding: 0; 
//                             font-family: Arial, sans-serif;
//                             background: white;
//                         }
//                         .page {
//                             width: 21cm;
//                             min-height: 29.7cm;
//                             margin: 0 auto 0.5cm auto;
//                             background: white;
//                             box-sizing: border-box;
//                             position: relative;
//                             page-break-after: always;
//                             border: 1px solid black;
//                         }
//                         .page:last-child {
//                             page-break-after: auto;
//                         }
//                         @media print {
//                             body { margin: 0; }
//                             .page { 
//                                 margin: 0; 
//                                 border: 1px solid black;
//                             }
//                         }
//                     </style>
//                 </head>
//                 <body>
//                     ${printContent.innerHTML}
//                 </body>
//             </html>
//         `);
//         WinPrint.document.close();
//         WinPrint.focus();
//         WinPrint.print();
//         WinPrint.close();
//     };

//     const formatDate = (dateString) => {
//         if (!dateString) {
//             return "N/A";
//         } else {
//             const date = new Date(dateString);
//             const day = String(date.getDate()).padStart(2, '0');
//             const month = String(date.getMonth() + 1).padStart(2, '0');
//             const year = date.getFullYear();
//             return `${day}-${month}-${year}`;
//         }
//     };

//     const totalamt = poData?.purchaseOrderItems?.map((item) => item.amount) || [];
//     const sum = totalamt?.reduce((accumulator, currentValue) => {
//         const currentAmount = Number(currentValue);
//         return accumulator + (isNaN(currentAmount) ? 0 : currentAmount);
//     }, 0);

//     const numberToWordsWithRupees = (num) => {
//         if (isNaN(num) || num === null || num === undefined) {
//             return "Zero Rupees Only";
//         }

//         const a = [
//             '', 'One', 'Two', 'Three', 'Four', 'Five', 'Six', 'Seven', 'Eight', 'Nine',
//             'Ten', 'Eleven', 'Twelve', 'Thirteen', 'Fourteen', 'Fifteen', 'Sixteen',
//             'Seventeen', 'Eighteen', 'Nineteen'
//         ];
//         const b = [
//             '', '', 'Twenty', 'Thirty', 'Forty', 'Fifty', 'Sixty', 'Seventy', 'Eighty', 'Ninety'
//         ];

//         const inWords = (num) => {
//             if (num < 20) return a[num];
//             if (num < 100) return b[Math.floor(num / 10)] + (num % 10 ? ' ' + a[num % 10] : '');
//             if (num < 1000)
//                 return a[Math.floor(num / 100)] + ' Hundred' + (num % 100 ? ' ' + inWords(num % 100) : '');
//             if (num < 100000)
//                 return inWords(Math.floor(num / 1000)) + ' Thousand' + (num % 1000 ? ' ' + inWords(num % 1000) : '');
//             if (num < 10000000)
//                 return inWords(Math.floor(num / 100000)) + ' Lakh' + (num % 100000 ? ' ' + inWords(num % 100000) : '');
//             return inWords(Math.floor(num / 10000000)) + ' Crore' + (num % 10000000 ? ' ' + inWords(num % 10000000) : '');
//         };

//         const amount = Math.round(Number(num));
//         const words = inWords(amount);
//         return `INR ${words} Only /-`;
//     };

//     const sumInWords = numberToWordsWithRupees(sum);
//     const getValue = (value, fallback = "N/A") => value || fallback;

//     const companyAddresses = poData?.branch?.company?.companyMultipleAddresses || [];
//     const worksAddress = companyAddresses[0]?.address || "W-95/96, MIDC, Phase II, Dombivli - (E) 421203, Mumbai India.";
//     const officeAddress = companyAddresses[1]?.address || "2nd Floor, Magnolia, Eden Woods Complex, Gladys Alwares Road, Thane (W) 400610, Mumbai India.";

//     // Calculate items per page for pagination
//     const itemsPerPage = 8;
//     const actualRows = poData?.purchaseOrderItems?.length || 0;
//     const totalPages = Math.ceil(actualRows / itemsPerPage);

//     if (isLoading) {
//         return (
//             <div style={{
//                 fontFamily: 'Arial, sans-serif',
//                 textAlign: 'center',
//                 padding: '40px 0'
//             }}>
//                 <Spinner animation="border" variant="primary" />
//                 <p style={{ marginTop: '8px' }}>Loading purchase order details...</p>
//             </div>
//         );
//     }

//     // Function to render a single page
//     const renderPage = (pageNumber) => {
//         const startIndex = (pageNumber - 1) * itemsPerPage;
//         const endIndex = Math.min(startIndex + itemsPerPage, actualRows);
//         const currentItems = poData?.purchaseOrderItems?.slice(startIndex, endIndex) || [];
//         const emptyRowsNeeded = Math.max(0, itemsPerPage - currentItems.length);
//         const isLastPage = pageNumber === totalPages;

//         return (
//             <div key={pageNumber} className="page" style={{
//                 width: '21cm',
//                 minHeight: '29.7cm',
//                 margin: '0 auto 0.5cm auto',
//                 background: 'white',
//                 color: 'black',
//                 fontFamily: 'Arial, sans-serif',
//                 fontSize: '12px',
//                 border: '1px solid black',
//                 boxSizing: 'border-box',
//                 position: 'relative'
//             }}>
//                 {/* Only show header on first page */}
//                 {pageNumber === 1 && (
//                     <div>
//                         {/* Header - SYNERGY Mechanics Pvt. Ltd. */}
//                         <div>
//                             <div style={{ textAlign: 'center' }}>
//                                 <div style={{
//                                     fontSize: '24px',
//                                     fontStyle: 'italic',
//                                     color: 'black',
//                                     fontWeight: 'bold',
//                                 }}>SYNERGY Mechanics Pvt. Ltd.</div>
//                             </div>

//                             <div style={{
//                                 borderTop: '1px solid black',
//                                 borderBottom: '1px solid black',
//                                 padding: '5px 0',
//                                 display: 'flex',
//                                 justifyContent: 'space-between',
//                                 alignItems: 'center'
//                             }}>
//                                 <div style={{ flex: '1', padding: '0 0 0 5px' }}>
//                                     <div style={{ display: 'flex', alignItems: 'flex-start', marginBottom: '2px' }}>
//                                         <div style={{ minWidth: '60px', fontWeight: '600', fontSize: '12px' }}>Works</div>
//                                         <span style={{ margin: '0 5px', fontWeight: '600' }}>:</span>
//                                         <div style={{ marginTop: 0, marginBottom: '0.3rem', fontSize: '12px', lineHeight: '1.2' }}>{worksAddress}</div>
//                                     </div>
//                                     <div style={{ display: 'flex', alignItems: 'flex-start', marginBottom: '2px' }}>
//                                         <div style={{ minWidth: '60px', fontWeight: '600', fontSize: '12px' }}>Office</div>
//                                         <span style={{ margin: '0 5px', fontWeight: '600' }}>:</span>
//                                         <div style={{ marginTop: 0, marginBottom: '0.3rem', fontSize: '12px', lineHeight: '1.2' }}>{officeAddress}</div>
//                                     </div>
//                                     <div style={{ display: 'flex', alignItems: 'flex-start', marginBottom: '2px' }}>
//                                         <div style={{ minWidth: '60px', fontWeight: '600', fontSize: '12px' }}>Ph. No.</div>
//                                         <span style={{ margin: '0 5px', fontWeight: '600' }}>:</span>
//                                         <div style={{ marginTop: 0, marginBottom: '0.3rem', fontSize: '12px', lineHeight: '1.2' }}>{getValue(poData?.branch?.company?.phoneno)}</div>
//                                     </div>
//                                     <div style={{ display: 'flex', alignItems: 'flex-start', marginBottom: '2px' }}>
//                                         <div style={{ minWidth: '60px', fontWeight: '600', fontSize: '12px' }}>Email</div>
//                                         <span style={{ margin: '0 5px', fontWeight: '600' }}>:</span>
//                                         <div style={{ marginTop: 0, marginBottom: '0.3rem', fontSize: '12px', lineHeight: '1.2' }}>{getValue(poData?.branch?.company?.email)}</div>
//                                     </div>
//                                     <div style={{ display: 'flex', alignItems: 'flex-start', marginBottom: '2px' }}>
//                                         <div style={{ minWidth: '60px', fontWeight: '600', fontSize: '12px' }}>GSTIN</div>
//                                         <span style={{ margin: '0 5px', fontWeight: '600' }}>:</span>
//                                         <div style={{ marginTop: 0, marginBottom: '0.3rem', fontSize: '12px', lineHeight: '1.2' }}>{getValue(poData?.branch?.company?.gstno)}</div>
//                                     </div>
//                                 </div>
//                                 <div style={{ flex: '0 0 auto', padding: '0 10px 0 0' }}>
//                                     <img
//                                         src="/assets/company-logo.png"
//                                         alt="Company Logo"
//                                         style={{ height: '130px', width: '130px', objectFit: 'contain' }}
//                                     />
//                                 </div>
//                             </div>

//                             {/* Po details */}
//                             <div>
//                                 <div style={{
//                                     fontSize: '18px',
//                                     fontWeight: '700',
//                                     textAlign: 'center',
//                                     borderBottom: '1px solid black',
//                                     padding: '5px 0',
//                                     marginBottom: '10px'
//                                 }}>
//                                     <div style={{ marginTop: 0, marginBottom: '0.3rem', fontSize: '18px', fontWeight: '700', lineHeight: '1.2' }}>PURCHASE ORDER</div>
//                                 </div>
//                                 <div style={{ display: 'flex', marginBottom: '10px' }}>
//                                     <div style={{ flex: '1', paddingRight: '10px', paddingLeft: '5px' }}>
//                                         <div style={{ marginBottom: '10px' }}>
//                                             <div style={{ fontSize: '14px', fontWeight: '700', marginBottom: '5px' }}>To,</div>
//                                             <div style={{ fontSize: '14px', fontWeight: '700', marginBottom: '5px' }}>{getValue(poData?.supplier?.companyname)}</div>
//                                         </div>

//                                         <div>
//                                             <div style={{ display: 'flex', alignItems: 'flex-start', marginBottom: '2px' }}>
//                                                 <div style={{ marginTop: 0, marginBottom: '0.3rem', fontSize: '12px', lineHeight: '1.2' }}>Office & Works</div>
//                                                 <div style={{ marginTop: 0, marginBottom: '0.3rem', fontSize: '12px', lineHeight: '1.2' }}><span style={{ margin: '0 3px', fontWeight: '600' }}>:</span>{getValue(poData?.supplierMultipleAddress?.supplieraddress)}</div>
//                                             </div>
//                                             <div style={{ display: 'flex', alignItems: 'flex-start', marginBottom: '2px' }}>
//                                                 <div style={{ marginTop: 0, marginBottom: '0.3rem', fontSize: '12px', lineHeight: '1.2' }}>Dist</div>
//                                                 <div style={{ marginTop: 0, marginBottom: '0.3rem', fontSize: '12px', lineHeight: '1.2' }}><span style={{ margin: '0 3px', fontWeight: '600' }}>:</span>{getValue(poData?.supplierMultipleAddress?.city?.cityname)}</div>
//                                             </div>
//                                             <div style={{ display: 'flex', alignItems: 'flex-start', marginBottom: '2px' }}>
//                                                 <div style={{ fontWeight: '600', fontSize: '12px' }}>Kind Attn</div>
//                                                 <div style={{ fontWeight: '600', fontSize: '12px' }}><span style={{ margin: '0 3px', fontWeight: '600' }}>:</span>{getValue(poData?.supplier?.contactperson)}</div>
//                                             </div>
//                                             <div style={{ display: 'flex', alignItems: 'flex-start', marginBottom: '2px' }}>
//                                                 <div style={{ fontWeight: '600', fontSize: '12px' }}>Contact No</div>
//                                                 <div style={{ fontWeight: '600', fontSize: '12px' }}><span style={{ margin: '0 3px', fontWeight: '600' }}>:</span>{getValue(poData?.supplier?.contactno)}</div>
//                                             </div>
//                                         </div>
//                                     </div>
//                                     <div style={{ flex: '1', borderLeft: '1px solid black', paddingLeft: '10px' }}>
//                                         <div style={{ marginBottom: '10px' }}>
//                                             <div style={{ display: 'flex', alignItems: 'center', marginBottom: '3px' }}>
//                                                 <div style={{ fontWeight: '600', fontSize: '12px' }}>Purchase Order No.</div>
//                                                 <div style={{ fontWeight: '600', fontSize: '12px' }}><span style={{ margin: '0 3px', fontWeight: '600' }}>:</span>{getValue(poData?.pono)}</div>
//                                             </div>
//                                             <div style={{ display: 'flex', alignItems: 'center', marginBottom: '3px' }}>
//                                                 <div style={{ fontWeight: '600', fontSize: '12px' }}>Purchase Order Dt.</div>
//                                                 <div style={{ fontWeight: '600', fontSize: '12px' }}><span style={{ margin: '0 3px', fontWeight: '600' }}>:</span>{formatDate(poData?.podate) || "N/A"}</div>
//                                             </div>
//                                         </div>
//                                         <div style={{ borderTop: '1px solid black', paddingTop: '5px' }}>
//                                             <div style={{ fontWeight: '600', fontSize: '12px' }}>Quotation Reference No.<span style={{ margin: '0 3px', fontWeight: '600' }}>:</span>{getValue(poData?.quotationreferencenumber)}</div>
//                                             <div style={{ fontWeight: '600', fontSize: '12px', marginTop: '5px' }}>Date<span style={{ margin: '0 5px 0 20px' }}>:</span>{formatDate(poData?.quotationreferencedate)}</div>
//                                         </div>
//                                     </div>
//                                 </div>
//                             </div>
//                         </div>
//                     </div>
//                 )}

//                 {/* Table for current page */}
//                 <table style={{
//                     width: '100%',
//                     borderCollapse: 'collapse',
//                     marginBottom: '10px'
//                 }}>
//                     <thead>
//                         <tr>
//                             <th style={{
//                                 borderTop: pageNumber === 1 ? '1px solid black' : 'none',
//                                 borderBottom: '1px solid black',
//                                 borderLeft: 'none',
//                                 borderRight: '1px solid black',
//                                 textAlign: 'center',
//                                 fontWeight: '700',
//                                 fontSize: '12px',
//                                 backgroundColor: '#f8f9fa',
//                                 width: '5%'
//                             }}>Sr. No.</th>
//                             <th style={{
//                                 borderTop: pageNumber === 1 ? '1px solid black' : 'none',
//                                 borderBottom: '1px solid black',
//                                 borderLeft: 'none',
//                                 borderRight: '1px solid black',
//                                 textAlign: 'center',
//                                 fontWeight: '700',
//                                 fontSize: '12px',
//                                 backgroundColor: '#f8f9fa',
//                                 width: '40%'
//                             }}>Description & Size</th>
//                             <th style={{
//                                 borderTop: pageNumber === 1 ? '1px solid black' : 'none',
//                                 borderBottom: '1px solid black',
//                                 borderLeft: 'none',
//                                 borderRight: '1px solid black',
//                                 textAlign: 'center',
//                                 fontWeight: '700',
//                                 fontSize: '12px',
//                                 backgroundColor: '#f8f9fa',
//                                 width: '15%'
//                             }}>Material Grade</th>
//                             <th style={{
//                                 borderTop: pageNumber === 1 ? '1px solid black' : 'none',
//                                 borderBottom: '1px solid black',
//                                 borderLeft: 'none',
//                                 borderRight: '1px solid black',
//                                 textAlign: 'center',
//                                 fontWeight: '700',
//                                 fontSize: '12px',
//                                 backgroundColor: '#f8f9fa',
//                                 width: '8%'
//                             }}>Qty. in {uom}</th>
//                             <th style={{
//                                 borderTop: pageNumber === 1 ? '1px solid black' : 'none',
//                                 borderBottom: '1px solid black',
//                                 borderLeft: 'none',
//                                 borderRight: '1px solid black',
//                                 textAlign: 'center',
//                                 fontWeight: '700',
//                                 fontSize: '12px',
//                                 backgroundColor: '#f8f9fa',
//                                 width: '17%'
//                             }}>Rate Per Unit INR</th>
//                             <th style={{
//                                 borderTop: pageNumber === 1 ? '1px solid black' : 'none',
//                                 borderBottom: '1px solid black',
//                                 borderLeft: 'none',
//                                 borderRight: 'none',
//                                 textAlign: 'center',
//                                 fontWeight: '700',
//                                 fontSize: '12px',
//                                 backgroundColor: '#f8f9fa',
//                                 width: '15%'
//                             }}>Amount in INR</th>
//                         </tr>
//                     </thead>
//                     <tbody>
//                         {currentItems.map((item, index) => (
//                             <tr key={startIndex + index}>
//                                 <td style={{
//                                     borderBottom: '1px solid black',
//                                     borderLeft: 'none',
//                                     borderRight: '1px solid black',
//                                     padding: '2px',
//                                     textAlign: 'center',
//                                     verticalAlign: 'top',
//                                     fontSize: '11px',
//                                     width: '5%'
//                                 }}>{startIndex + index + 1}</td>
//                                 <td style={{
//                                     borderBottom: '1px solid black',
//                                     borderLeft: 'none',
//                                     borderRight: '1px solid black',
//                                     padding: '2px',
//                                     textAlign: 'left',
//                                     verticalAlign: 'top',
//                                     fontSize: '11px',
//                                     width: '40%'
//                                 }}>
//                                     <div style={{
//                                         fontSize: '11px',
//                                         fontWeight: '600',
//                                         textAlign: 'left',
//                                         marginBottom: '2px'
//                                     }}>{getValue(item?.product?.description)}</div>
//                                     <div style={{
//                                         fontSize: '10px',
//                                         textAlign: 'left',
//                                         marginBottom: '2px',
//                                         color: '#666'
//                                     }}>PART No.{getValue(item?.partno)}</div>
//                                     <div style={{
//                                         fontSize: '10px',
//                                         textAlign: 'left',
//                                         marginBottom: '2px',
//                                         color: '#666'
//                                     }}>JOB NO.{getValue(poData?.jobnumber)}</div>
//                                     <div style={{
//                                         fontSize: '10px',
//                                         textAlign: 'left',
//                                         fontStyle: 'italic',
//                                         color: '#666',
//                                         marginBottom: '2px'
//                                     }}>{getValue(item?.productremarks)}</div>
//                                 </td>
//                                 <td style={{
//                                     borderBottom: '1px solid black',
//                                     borderLeft: 'none',
//                                     borderRight: '1px solid black',
//                                     padding: '2px',
//                                     textAlign: 'center',
//                                     verticalAlign: 'top',
//                                     fontSize: '11px',
//                                     width: '15%'
//                                 }}>{getValue(item?.product?.moc)}</td>
//                                 <td style={{
//                                     borderBottom: '1px solid black',
//                                     borderLeft: 'none',
//                                     borderRight: '1px solid black',
//                                     padding: '2px',
//                                     textAlign: 'center',
//                                     verticalAlign: 'top',
//                                     fontSize: '11px',
//                                     width: '8%'
//                                 }}>{getValue(item?.quantity, 0)}</td>
//                                 <td style={{
//                                     borderBottom: '1px solid black',
//                                     borderLeft: 'none',
//                                     borderRight: '1px solid black',
//                                     padding: '2px',
//                                     textAlign: 'right',
//                                     verticalAlign: 'top',
//                                     fontSize: '11px',
//                                     width: '17%'
//                                 }}>{getValue(item?.unitrateinr, 0)}</td>
//                                 <td style={{
//                                     borderBottom: '1px solid black',
//                                     borderLeft: 'none',
//                                     borderRight: 'none',
//                                     padding: '2px',
//                                     textAlign: 'right',
//                                     verticalAlign: 'top',
//                                     fontSize: '11px',
//                                     width: '15%'
//                                 }}>{getValue(item?.amount, 0)}</td>
//                             </tr>
//                         ))}

//                         {/* Empty Rows */}
//                         {Array.from({ length: emptyRowsNeeded }).map((_, index) => (
//                             <tr key={`empty-${index}`}>
//                                 <td style={{
//                                     borderBottom: '1px solid black',
//                                     borderLeft: 'none',
//                                     borderRight: '1px solid black',
//                                     padding: '2px',
//                                     textAlign: 'center',
//                                     verticalAlign: 'top',
//                                     fontSize: '11px',
//                                     width: '5%'
//                                 }}>&nbsp;</td>
//                                 <td style={{
//                                     borderBottom: '1px solid black',
//                                     borderLeft: 'none',
//                                     borderRight: '1px solid black',
//                                     padding: '2px',
//                                     textAlign: 'left',
//                                     verticalAlign: 'top',
//                                     fontSize: '11px',
//                                     width: '40%'
//                                 }}>&nbsp;</td>
//                                 <td style={{
//                                     borderBottom: '1px solid black',
//                                     borderLeft: 'none',
//                                     borderRight: '1px solid black',
//                                     padding: '2px',
//                                     textAlign: 'center',
//                                     verticalAlign: 'top',
//                                     fontSize: '11px',
//                                     width: '15%'
//                                 }}>&nbsp;</td>
//                                 <td style={{
//                                     borderBottom: '1px solid black',
//                                     borderLeft: 'none',
//                                     borderRight: '1px solid black',
//                                     padding: '2px',
//                                     textAlign: 'center',
//                                     verticalAlign: 'top',
//                                     fontSize: '11px',
//                                     width: '8%'
//                                 }}>&nbsp;</td>
//                                 <td style={{
//                                     borderBottom: '1px solid black',
//                                     borderLeft: 'none',
//                                     borderRight: '1px solid black',
//                                     padding: '2px',
//                                     textAlign: 'right',
//                                     verticalAlign: 'top',
//                                     fontSize: '11px',
//                                     width: '17%'
//                                 }}>&nbsp;</td>
//                                 <td style={{
//                                     borderBottom: '1px solid black',
//                                     borderLeft: 'none',
//                                     borderRight: 'none',
//                                     padding: '2px',
//                                     textAlign: 'right',
//                                     verticalAlign: 'top',
//                                     fontSize: '11px',
//                                     width: '15%'
//                                 }}>&nbsp;</td>
//                             </tr>
//                         ))}
//                         {isLastPage && (
//                             <tr style={{ borderBottom: '1px solid black' }}>
//                                 <td style={{
//                                     borderBottom: '1px solid black',
//                                     borderLeft: 'none',
//                                     borderRight: '1px solid black',
//                                     padding: '8px',
//                                     textAlign: 'right',
//                                     fontWeight: '700',
//                                     fontSize: '12px'
//                                 }}></td>
//                                 <td
//                                     colSpan={0}
//                                     style={{
//                                         fontSize: '11px',
//                                         textAlign: 'left',
//                                         fontStyle: 'italic',
//                                         marginTop: '1px',
//                                         color: '#222',
//                                         borderTop: '1px dashed #aaa',
//                                         paddingTop: '1px',
//                                     }}
//                                 >
//                                     <span
//                                         style={{
//                                             backgroundColor: '#f7eb9f', // light soft yellow
//                                             padding: '1px 1px',
//                                             borderRadius: '3px',
//                                         }}
//                                     >
//                                         Notes: {getValue(poData?.remarks)}
//                                     </span>
//                                 </td>
//                                 <td style={{
//                                     borderBottom: '1px solid black',
//                                     borderLeft: 'none',
//                                     borderRight: '1px solid black',
//                                     padding: '8px',
//                                     textAlign: 'right',
//                                     fontWeight: '700',
//                                     fontSize: '12px'
//                                 }}></td>

//                                 <td colSpan={0} style={{
//                                     borderBottom: '1px solid black',
//                                     borderLeft: 'none',
//                                     borderRight: '1px solid black',
//                                     padding: '8px',
//                                     textAlign: 'right',
//                                     fontWeight: '700',
//                                     fontSize: '12px'
//                                 }}>Total</td>
//                                 <td style={{
//                                     borderBottom: '1px solid black',
//                                     borderLeft: 'none',
//                                     borderRight: '1px solid black',
//                                     padding: '8px',
//                                     textAlign: 'right',
//                                     fontWeight: '700',
//                                     fontSize: '12px'
//                                 }}></td>
//                                 <td style={{
//                                     borderBottom: '1px solid black',
//                                     borderLeft: 'none',
//                                     borderRight: 'none',
//                                     padding: '8px',
//                                     textAlign: 'right',
//                                     fontWeight: '700',
//                                     fontSize: '12px'
//                                 }}>{sum}</td>

//                             </tr>
//                         )}

//                         {/* Total Rows - Only on last page */}
//                         {isLastPage && (
//                             <>
//                                 <tr style={{ borderBottom: '1px solid black' }}>
//                                     <td colSpan={6} style={{
//                                         borderBottom: '1px solid black',
//                                         borderLeft: 'none',
//                                         borderRight: 'none',
//                                         padding: '5px',
//                                         textAlign: 'left',
//                                         fontWeight: '700',
//                                         fontSize: '12px',
//                                         textTransform: 'capitalize'
//                                     }}>
//                                         In Words: {sumInWords}
//                                     </td>
//                                 </tr>
//                             </>
//                         )}
//                     </tbody>
//                 </table>

//                 {/* Footer - Only on last page */}
//                 {isLastPage && (
//                     <div style={{
//                         // borderTop: '1px solid black',
//                         display: 'flex',
//                         marginTop: '10px'
//                     }}>
//                         <div style={{ flex: '1.6', paddingRight: '10px', paddingLeft: '5px' }}>
//                             <div style={{ marginBottom: '10px', borderBottom: '1px solid black', paddingBottom: '8px' }}>
//                                 <div style={{ display: 'flex', alignItems: 'center', marginBottom: '4px' }}>
//                                     <div style={{ minWidth: '120px', fontWeight: '600', fontSize: '13px' }}>GST</div>
//                                     <span style={{ margin: '0 5px', fontWeight: '600' }}>:</span>
//                                     <div style={{ fontSize: '13px', lineHeight: '1.3' }}>As Applicable</div>
//                                 </div>
//                                 <div style={{ display: 'flex', alignItems: 'center', marginBottom: '4px' }}>
//                                     <div style={{ minWidth: '120px', fontWeight: '600', fontSize: '13px' }}>P & F Charges</div>
//                                     <span style={{ margin: '0 5px', fontWeight: '600' }}>:</span>
//                                     <div style={{ fontSize: '13px', lineHeight: '1.3' }}>{getValue(poData?.pandf, "NIL")}</div>
//                                 </div>
//                                 <div style={{ display: 'flex', alignItems: 'center', marginBottom: '4px' }}>
//                                     <div style={{ minWidth: '120px', fontWeight: '600', fontSize: '13px' }}>Freight Charges</div>
//                                     <span style={{ margin: '0 5px', fontWeight: '600' }}>:</span>
//                                     <div style={{ fontSize: '13px', lineHeight: '1.3' }}>{getValue(poData?.freight, "NIL")}</div>
//                                 </div>
//                                 <div style={{ display: 'flex', alignItems: 'center', marginBottom: '4px' }}>
//                                     <div style={{ minWidth: '120px', fontWeight: '600', fontSize: '13px' }}>Payment Terms</div>
//                                     <span style={{ margin: '0 5px', fontWeight: '600' }}>:</span>
//                                     <div style={{ fontSize: '13px', lineHeight: '1.3' }}>{getValue(poData?.paymentterms)}</div>
//                                 </div>
//                                 <div style={{ display: 'flex', alignItems: 'center', marginBottom: '4px' }}>
//                                     <div style={{ minWidth: '120px', fontWeight: '600', fontSize: '13px' }}>Certificate</div>
//                                     <span style={{ margin: '0 5px', fontWeight: '600' }}>:</span>
//                                     <div style={{ fontSize: '13px', lineHeight: '1.3' }}>{getValue(poData?.certificate)}</div>
//                                 </div>
//                                 <div style={{ display: 'flex', alignItems: 'center', marginBottom: '4px' }}>
//                                     <div style={{ minWidth: '120px', fontWeight: '600', fontSize: '13px' }}>Delivery Time</div>
//                                     <span style={{ margin: '0 5px', fontWeight: '600' }}>:</span>
//                                     <div style={{ fontSize: '13px', lineHeight: '1.3' }}>{getValue(poData?.deliverytime)}</div>
//                                 </div>
//                             </div>

//                             <div style={{ marginTop: '10px' }}>
//                                 <div style={{ fontSize: '12px', fontWeight: '600', marginBottom: '5px' }}>Delivery Address</div>
//                                 <div style={{ marginTop: 0, marginBottom: '0.3rem', fontSize: '12px', lineHeight: '1.2' }}>{getValue(poData?.branch?.company?.companyname)}</div>
//                                 <div style={{ display: 'flex', alignItems: 'flex-start', marginBottom: '2px' }}>
//                                     <div style={{ marginTop: 0, marginBottom: '0.3rem', fontSize: '12px', lineHeight: '1.2' }}>Works</div>
//                                     <span style={{ margin: '0 3px', fontWeight: '600' }}>:</span>
//                                     <div style={{ marginTop: 0, marginBottom: '0.3rem', fontSize: '12px', lineHeight: '1.2' }}>{getValue(poData?.warehouse?.address)}</div>
//                                 </div>
//                                 <div style={{ display: 'flex', alignItems: 'flex-start', marginBottom: '2px' }}>
//                                     <div style={{ marginTop: 0, marginBottom: '0.3rem', fontSize: '12px', lineHeight: '1.2' }}>Dist</div>
//                                     <span style={{ margin: '0 3px', fontWeight: '600' }}>:</span>
//                                     <div style={{ marginTop: 0, marginBottom: '0.3rem', fontSize: '12px', lineHeight: '1.2' }}>{getValue(poData?.warehouse?.city?.cityname)}</div>
//                                 </div>
//                                 <div style={{ display: 'flex', alignItems: 'flex-start', marginBottom: '2px' }}>
//                                     <div style={{ marginTop: 0, marginBottom: '0.3rem', fontSize: '12px', lineHeight: '1.2' }}>State</div>
//                                     <span style={{ margin: '0 3px', fontWeight: '600' }}>:</span>
//                                     <div style={{ marginTop: 0, marginBottom: '0.3rem', fontSize: '12px', lineHeight: '1.2' }}>{getValue(poData?.warehouse?.state?.statename)}</div>
//                                 </div>
//                             </div>
//                         </div>
//                         <div style={{ flex: '1', borderLeft: '1px solid black', paddingLeft: '10px' }}>
//                             <div style={{ marginTop: 0, marginBottom: '0.3rem', fontSize: '12px', lineHeight: '1.2' }}>For,</div>
//                             <div style={{ padding: '0px 0px 100px 0px', fontWeight: '700', fontStyle: 'italic', fontSize: '14px' }}>SYNERGY Mechanics Pvt. Ltd.</div>
//                             <div style={{ fontSize: '12px', fontWeight: '600', textAlign: 'center' }}>Authorised Signatory</div>
//                         </div>
//                     </div>
//                 )}

//                 {/* Page number */}
//                 <div style={{
//                     position: 'absolute',
//                     bottom: '10px',
//                     right: '10px',
//                     fontSize: '10px',
//                     color: '#666'
//                 }}>
//                     Page {pageNumber} of {totalPages}
//                 </div>
//             </div>
//         );
//     };

//     return (
//         <>
//             <style>
//                 {`
//                     @media print {
//                         body * {
//                             visibility: hidden;
//                         }
//                         .print-section, .print-section * {
//                             visibility: visible;
//                         }
//                         .print-section {
//                             position: absolute;
//                             left: 0;
//                             top: 0;
//                             width: 100%;
//                             padding: 0;
//                             margin: 0;
//                         }
//                         .no-print {
//                             display: none !important;
//                         }
//                         .page {
//                             page-break-after: always;
//                             border: 1px solid black !important;
//                         }
//                         .page:last-child {
//                             page-break-after: auto;
//                         }
//                         @page {
//                             margin: 0.5cm;
//                             size: A4;
//                         }
//                     }
//                 `}
//             </style>

//             <div className="no-print" style={{
//                 display: 'flex',
//                 gap: '8px',
//                 justifyContent: 'center',
//                 marginBottom: '12px',
//                 padding: '10px'
//             }}>
//                 <button className="btn btn-secondary" onClick={() => navigate(-1)}>
//                     ← Back
//                 </button>
//                 <button className="btn btn-primary" onClick={handlePrint}>
//                     🖨️ Print Purchase Order
//                 </button>
//             </div>

//             <div ref={printRef} className="print-section">
//                 {Array.from({ length: totalPages }, (_, i) => renderPage(i + 1))}
//             </div>
//         </>
//     );
// };

// export default PoDomPrint;




import React, { useEffect, useState, useRef } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { Spinner } from 'react-bootstrap';
import axios from 'axios';
import { BASE_URL } from '../../../services/Api';
import { authHeader } from '../../../services/auth-header';

const PoDomPrint = () => {
    const { id } = useParams();
    const navigate = useNavigate();
    const [isLoading, setIsLoading] = useState(true);
    const [poData, setPoData] = useState({});
    const [uom, setUom] = useState('Nos.');
    const printRef = useRef();

    const PoPrintData = async () => {
        try {
            const response = await axios.get(`${BASE_URL}purchaseOrder/findById/${id}`, {
                headers: authHeader(),
            });
            const data = response.data;
            setPoData(data);

            if (data.purchaseOrderItems && data.purchaseOrderItems.length > 0) {
                const firstItem = data.purchaseOrderItems[0];
                setUom(firstItem.uom || 'Nos.');
            }

            console.log(response.data);
        } catch (error) {
            console.error("Error fetching po data", error);
        } finally {
            setIsLoading(false);
        }
    };

    useEffect(() => {
        PoPrintData();
    }, [id]);

    const handlePrint = () => {
        const printContent = printRef.current;
        const WinPrint = window.open('', '', 'width=900,height=650');

        WinPrint.document.write(`
            <html>
                <head>
                    <title>Purchase Order</title>
                    <style>
                        body { 
                            margin: 0; 
                            padding: 0; 
                            font-family: Arial, sans-serif;
                            background: white;
                        }
                        .page {
                            width: 21cm;
                            min-height: 29.7cm;
                            margin: 0 auto 0.5cm auto;
                            background: white;
                            box-sizing: border-box;
                            position: relative;
                            page-break-after: always;
                            border: 1px solid black !important;
                        }
                        .page:last-child {
                            page-break-after: auto;
                        }
                        @media print {
                            body { 
                                margin: 0; 
                                padding: 0;
                                -webkit-print-color-adjust: exact;
                                color-adjust: exact;
                            }
                            .page { 
                                margin: 0 auto;
                                border: 1px solid black !important;
                                box-shadow: none;
                            }
                            @page {
                                margin: 1cm;
                                size: A4;
                            }
                        }
                    </style>
                </head>
                <body>
                    ${printContent.innerHTML}
                </body>
            </html>
        `);
        WinPrint.document.close();
        WinPrint.focus();
        WinPrint.print();
        WinPrint.close();
    };

    const formatDate = (dateString) => {
        if (!dateString) {
            return "N/A";
        } else {
            const date = new Date(dateString);
            const day = String(date.getDate()).padStart(2, '0');
            const month = String(date.getMonth() + 1).padStart(2, '0');
            const year = date.getFullYear();
            return `${day}-${month}-${year}`;
        }
    };

    const totalamt = poData?.purchaseOrderItems?.map((item) => item.amount) || [];
    const sum = totalamt?.reduce((accumulator, currentValue) => {
        const currentAmount = Number(currentValue);
        return accumulator + (isNaN(currentAmount) ? 0 : currentAmount);
    }, 0);

    const numberToWordsWithRupees = (num) => {
        if (isNaN(num) || num === null || num === undefined) {
            return "Zero Rupees Only";
        }

        const a = [
            '', 'One', 'Two', 'Three', 'Four', 'Five', 'Six', 'Seven', 'Eight', 'Nine',
            'Ten', 'Eleven', 'Twelve', 'Thirteen', 'Fourteen', 'Fifteen', 'Sixteen',
            'Seventeen', 'Eighteen', 'Nineteen'
        ];
        const b = [
            '', '', 'Twenty', 'Thirty', 'Forty', 'Fifty', 'Sixty', 'Seventy', 'Eighty', 'Ninety'
        ];

        const inWords = (num) => {
            if (num < 20) return a[num];
            if (num < 100) return b[Math.floor(num / 10)] + (num % 10 ? ' ' + a[num % 10] : '');
            if (num < 1000)
                return a[Math.floor(num / 100)] + ' Hundred' + (num % 100 ? ' ' + inWords(num % 100) : '');
            if (num < 100000)
                return inWords(Math.floor(num / 1000)) + ' Thousand' + (num % 1000 ? ' ' + inWords(num % 1000) : '');
            if (num < 10000000)
                return inWords(Math.floor(num / 100000)) + ' Lakh' + (num % 100000 ? ' ' + inWords(num % 100000) : '');
            return inWords(Math.floor(num / 10000000)) + ' Crore' + (num % 10000000 ? ' ' + inWords(num % 10000000) : '');
        };

        const amount = Math.round(Number(num));
        const words = inWords(amount);
        return `INR ${words} Only /-`;
    };

    const sumInWords = numberToWordsWithRupees(sum);
    const getValue = (value, fallback = "N/A") => value || fallback;

    const companyAddresses = poData?.branch?.company?.companyMultipleAddresses || [];
    const worksAddress = companyAddresses[0]?.address || "W-95/96, MIDC, Phase II, Dombivli - (E) 421203, Mumbai India.";
    const officeAddress = companyAddresses[1]?.address || "2nd Floor, Magnolia, Eden Woods Complex, Gladys Alwares Road, Thane (W) 400610, Mumbai India.";

    // Calculate items per page for pagination
    const itemsPerPage = 8;
    const actualRows = poData?.purchaseOrderItems?.length || 0;
    const totalPages = Math.ceil(actualRows / itemsPerPage);

    if (isLoading) {
        return (
            <div style={{
                fontFamily: 'Arial, sans-serif',
                textAlign: 'center',
                padding: '40px 0'
            }}>
                <Spinner animation="border" variant="primary" />
                <p style={{ marginTop: '8px', fontSize: '16px' }}>Loading purchase order details...</p>
            </div>
        );
    }

    // Function to render a single page
    const renderPage = (pageNumber) => {
        const startIndex = (pageNumber - 1) * itemsPerPage;
        const endIndex = Math.min(startIndex + itemsPerPage, actualRows);
        const currentItems = poData?.purchaseOrderItems?.slice(startIndex, endIndex) || [];
        const emptyRowsNeeded = Math.max(0, itemsPerPage - currentItems.length);
        const isLastPage = pageNumber === totalPages;

        return (
            <div key={pageNumber} className="page" style={{
                width: '21cm',
                minHeight: '29.7cm',
                margin: '0 auto 0.5cm auto',
                background: 'white',
                color: 'black',
                fontFamily: 'Arial, sans-serif',
                fontSize: '14px',
                border: '1px solid black',
                boxSizing: 'border-box',
                position: 'relative',
                padding: '0' // Remove any padding that might cause border issues
            }}>
                {/* Only show header on first page */}
                {pageNumber === 1 && (
                    <div style={{ padding: '0 15px' }}> {/* Add padding instead of margin for better border control */}
                        {/* Header - SYNERGY Mechanics Pvt. Ltd. */}
                        <div>
                            <div style={{ textAlign: 'center', padding: '10px 0' }}>
                                <div style={{
                                    fontSize: '26px',
                                    fontStyle: 'italic',
                                    color: 'black',
                                    fontWeight: 'bold',
                                }}>SYNERGY Mechanics Pvt. Ltd.</div>
                            </div>

                            <div style={{
                                borderTop: '1px solid black',
                                borderBottom: '1px solid black',
                                padding: '8px 0',
                                display: 'flex',
                                justifyContent: 'space-between',
                                alignItems: 'center'
                            }}>
                                <div style={{ flex: '1', padding: '0 0 0 8px' }}>
                                    <div style={{ display: 'flex', alignItems: 'flex-start', marginBottom: '4px' }}>
                                        <div style={{ minWidth: '60px', fontWeight: '600', fontSize: '14px' }}>Works</div>
                                        <span style={{ margin: '0 6px', fontWeight: '600' }}>:</span>
                                        <div style={{ marginTop: 0, marginBottom: '0.3rem', fontSize: '14px', lineHeight: '1.3' }}>{worksAddress}</div>
                                    </div>
                                    <div style={{ display: 'flex', alignItems: 'flex-start', marginBottom: '4px' }}>
                                        <div style={{ minWidth: '60px', fontWeight: '600', fontSize: '14px' }}>Office</div>
                                        <span style={{ margin: '0 6px', fontWeight: '600' }}>:</span>
                                        <div style={{ marginTop: 0, marginBottom: '0.3rem', fontSize: '14px', lineHeight: '1.3' }}>{officeAddress}</div>
                                    </div>
                                    <div style={{ display: 'flex', alignItems: 'flex-start', marginBottom: '4px' }}>
                                        <div style={{ minWidth: '60px', fontWeight: '600', fontSize: '14px' }}>Ph. No.</div>
                                        <span style={{ margin: '0 6px', fontWeight: '600' }}>:</span>
                                        <div style={{ marginTop: 0, marginBottom: '0.3rem', fontSize: '14px', lineHeight: '1.3' }}>{getValue(poData?.branch?.company?.phoneno)}</div>
                                    </div>
                                    <div style={{ display: 'flex', alignItems: 'flex-start', marginBottom: '4px' }}>
                                        <div style={{ minWidth: '60px', fontWeight: '600', fontSize: '14px' }}>Email</div>
                                        <span style={{ margin: '0 6px', fontWeight: '600' }}>:</span>
                                        <div style={{ marginTop: 0, marginBottom: '0.3rem', fontSize: '14px', lineHeight: '1.3' }}>{getValue(poData?.branch?.company?.email)}</div>
                                    </div>
                                    <div style={{ display: 'flex', alignItems: 'flex-start', marginBottom: '4px' }}>
                                        <div style={{ minWidth: '60px', fontWeight: '600', fontSize: '14px' }}>GSTIN</div>
                                        <span style={{ margin: '0 6px', fontWeight: '600' }}>:</span>
                                        <div style={{ marginTop: 0, marginBottom: '0.3rem', fontSize: '14px', lineHeight: '1.3' }}>{getValue(poData?.branch?.company?.gstno)}</div>
                                    </div>
                                </div>
                                <div style={{ flex: '0 0 auto', padding: '0 12px 0 0' }}>
                                    <img
                                        src="/assets/company-logo.png"
                                        alt="Company Logo"
                                        style={{ height: '140px', width: '140px', objectFit: 'contain' }}
                                    />
                                </div>
                            </div>

                            {/* Po details */}
                            <div style={{ padding: '10px 0' }}>
                                <div style={{
                                    fontSize: '20px',
                                    fontWeight: '700',
                                    textAlign: 'center',
                                    borderBottom: '1px solid black',
                                    padding: '8px 0',
                                    marginBottom: '12px'
                                }}>
                                    <div style={{ marginTop: 0, marginBottom: '0.3rem', fontSize: '20px', fontWeight: '700', lineHeight: '1.2' }}>PURCHASE ORDER</div>
                                </div>
                                <div style={{ display: 'flex', marginBottom: '12px' }}>
                                    <div style={{ flex: '1', paddingRight: '12px' }}>
                                        <div style={{ marginBottom: '12px' }}>
                                            <div style={{ fontSize: '16px', fontWeight: '700', marginBottom: '6px' }}>To,</div>
                                            <div style={{ fontSize: '16px', fontWeight: '700', marginBottom: '6px' }}>{getValue(poData?.supplier?.companyname)}</div>
                                        </div>

                                        <div>
                                            <div style={{ display: 'flex', alignItems: 'flex-start', marginBottom: '4px' }}>
                                                <div style={{ marginTop: 0, marginBottom: '0.3rem', fontSize: '14px', lineHeight: '1.3' }}>Office & Works</div>
                                                <div style={{ marginTop: 0, marginBottom: '0.3rem', fontSize: '14px', lineHeight: '1.3' }}><span style={{ margin: '0 4px', fontWeight: '600' }}>:</span>{getValue(poData?.supplierMultipleAddress?.supplieraddress)}</div>
                                            </div>
                                            <div style={{ display: 'flex', alignItems: 'flex-start', marginBottom: '4px' }}>
                                                <div style={{ marginTop: 0, marginBottom: '0.3rem', fontSize: '14px', lineHeight: '1.3' }}>Dist</div>
                                                <div style={{ marginTop: 0, marginBottom: '0.3rem', fontSize: '14px', lineHeight: '1.3' }}><span style={{ margin: '0 4px', fontWeight: '600' }}>:</span>{getValue(poData?.supplierMultipleAddress?.city?.cityname)}</div>
                                            </div>
                                            <div style={{ display: 'flex', alignItems: 'flex-start', marginBottom: '4px' }}>
                                                <div style={{ fontWeight: '600', fontSize: '14px' }}>Kind Attn</div>
                                                <div style={{ fontWeight: '600', fontSize: '14px' }}><span style={{ margin: '0 4px', fontWeight: '600' }}>:</span>{getValue(poData?.supplier?.contactperson)}</div>
                                            </div>
                                            <div style={{ display: 'flex', alignItems: 'flex-start', marginBottom: '4px' }}>
                                                <div style={{ fontWeight: '600', fontSize: '14px' }}>Contact No</div>
                                                <div style={{ fontWeight: '600', fontSize: '14px' }}><span style={{ margin: '0 4px', fontWeight: '600' }}>:</span>{getValue(poData?.supplier?.contactno)}</div>
                                            </div>
                                        </div>
                                    </div>
                                    <div style={{ flex: '1', borderLeft: '1px solid black', paddingLeft: '12px' }}>
                                        <div style={{ marginBottom: '12px' }}>
                                            <div style={{ display: 'flex', alignItems: 'center', marginBottom: '4px' }}>
                                                <div style={{ fontWeight: '600', fontSize: '14px' }}>Purchase Order No.</div>
                                                <div style={{ fontWeight: '600', fontSize: '14px' }}><span style={{ margin: '0 4px', fontWeight: '600' }}>:</span>{getValue(poData?.pono)}</div>
                                            </div>
                                            <div style={{ display: 'flex', alignItems: 'center', marginBottom: '4px' }}>
                                                <div style={{ fontWeight: '600', fontSize: '14px' }}>Purchase Order Dt.</div>
                                                <div style={{ fontWeight: '600', fontSize: '14px' }}><span style={{ margin: '0 4px', fontWeight: '600' }}>:</span>{formatDate(poData?.podate) || "N/A"}</div>
                                            </div>
                                        </div>
                                        <div style={{ borderTop: '1px solid black', paddingTop: '6px' }}>
                                            <div style={{ fontWeight: '600', fontSize: '14px' }}>Quotation Reference No.<span style={{ margin: '0 4px', fontWeight: '600' }}>:</span>{getValue(poData?.quotationreferencenumber)}</div>
                                            <div style={{ fontWeight: '600', fontSize: '14px', marginTop: '6px' }}>Date<span style={{ margin: '0 6px 0 24px' }}>:</span>{formatDate(poData?.quotationreferencedate)}</div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                )}

                {/* Table for current page */}
                <div style={{ padding: '0 15px' }}> {/* Add padding for table container */}
                    <table style={{
                        width: '100%',
                        borderCollapse: 'collapse',
                        marginBottom: '12px'
                    }}>
                        <thead>
                            <tr>
                                <th style={{
                                    border: '1px solid black',
                                    textAlign: 'center',
                                    fontWeight: '700',
                                    fontSize: '14px',
                                    backgroundColor: '#f8f9fa',
                                    width: '5%',
                                    padding: '6px'
                                }}>Sr. No.</th>
                                <th style={{
                                    border: '1px solid black',
                                    textAlign: 'center',
                                    fontWeight: '700',
                                    fontSize: '14px',
                                    backgroundColor: '#f8f9fa',
                                    width: '40%',
                                    padding: '6px'
                                }}>Description & Size</th>
                                <th style={{
                                    border: '1px solid black',
                                    textAlign: 'center',
                                    fontWeight: '700',
                                    fontSize: '14px',
                                    backgroundColor: '#f8f9fa',
                                    width: '15%',
                                    padding: '6px'
                                }}>Material Grade</th>
                                <th style={{
                                    border: '1px solid black',
                                    textAlign: 'center',
                                    fontWeight: '700',
                                    fontSize: '14px',
                                    backgroundColor: '#f8f9fa',
                                    width: '8%',
                                    padding: '6px'
                                }}>Qty. in {uom}</th>
                                <th style={{
                                    border: '1px solid black',
                                    textAlign: 'center',
                                    fontWeight: '700',
                                    fontSize: '14px',
                                    backgroundColor: '#f8f9fa',
                                    width: '17%',
                                    padding: '6px'
                                }}>Rate Per Unit INR</th>
                                <th style={{
                                    border: '1px solid black',
                                    textAlign: 'center',
                                    fontWeight: '700',
                                    fontSize: '14px',
                                    backgroundColor: '#f8f9fa',
                                    width: '15%',
                                    padding: '6px'
                                }}>Amount in INR</th>
                            </tr>
                        </thead>
                        <tbody>
                            {currentItems.map((item, index) => (
                                <tr key={startIndex + index}>
                                    <td style={{
                                        border: '1px solid black',
                                        padding: '4px',
                                        textAlign: 'center',
                                        verticalAlign: 'top',
                                        fontSize: '13px',
                                        width: '5%'
                                    }}>{startIndex + index + 1}</td>
                                    <td style={{
                                        border: '1px solid black',
                                        padding: '4px',
                                        textAlign: 'left',
                                        verticalAlign: 'top',
                                        fontSize: '13px',
                                        width: '40%'
                                    }}>
                                        <div style={{
                                            fontSize: '13px',
                                            fontWeight: '600',
                                            textAlign: 'left',
                                            marginBottom: '3px'
                                        }}>{getValue(item?.product?.description)}</div>
                                        <div style={{
                                            fontSize: '12px',
                                            textAlign: 'left',
                                            marginBottom: '3px',
                                            color: '#666'
                                        }}>PART No.{getValue(item?.partno)}</div>
                                        <div style={{
                                            fontSize: '12px',
                                            textAlign: 'left',
                                            marginBottom: '3px',
                                            color: '#666'
                                        }}>JOB NO.{getValue(poData?.jobnumber)}</div>
                                        <div style={{
                                            fontSize: '12px',
                                            textAlign: 'left',
                                            fontStyle: 'italic',
                                            color: '#666',
                                            marginBottom: '3px'
                                        }}>{getValue(item?.productremarks)}</div>
                                    </td>
                                    <td style={{
                                        border: '1px solid black',
                                        padding: '4px',
                                        textAlign: 'center',
                                        verticalAlign: 'top',
                                        fontSize: '13px',
                                        width: '15%'
                                    }}>{getValue(item?.product?.moc)}</td>
                                    <td style={{
                                        border: '1px solid black',
                                        padding: '4px',
                                        textAlign: 'center',
                                        verticalAlign: 'top',
                                        fontSize: '13px',
                                        width: '8%'
                                    }}>{getValue(item?.quantity, 0)}</td>
                                    <td style={{
                                        border: '1px solid black',
                                        padding: '4px',
                                        textAlign: 'right',
                                        verticalAlign: 'top',
                                        fontSize: '13px',
                                        width: '17%'
                                    }}>{getValue(item?.unitrateinr, 0)}</td>
                                    <td style={{
                                        border: '1px solid black',
                                        padding: '4px',
                                        textAlign: 'right',
                                        verticalAlign: 'top',
                                        fontSize: '13px',
                                        width: '15%'
                                    }}>{getValue(item?.amount, 0)}</td>
                                </tr>
                            ))}

                            {/* Empty Rows */}
                            {Array.from({ length: emptyRowsNeeded }).map((_, index) => (
                                <tr key={`empty-${index}`}>
                                    <td style={{
                                        border: '1px solid black',
                                        padding: '4px',
                                        textAlign: 'center',
                                        verticalAlign: 'top',
                                        fontSize: '13px',
                                        width: '5%'
                                    }}>&nbsp;</td>
                                    <td style={{
                                        border: '1px solid black',
                                        padding: '4px',
                                        textAlign: 'left',
                                        verticalAlign: 'top',
                                        fontSize: '13px',
                                        width: '40%'
                                    }}>&nbsp;</td>
                                    <td style={{
                                        border: '1px solid black',
                                        padding: '4px',
                                        textAlign: 'center',
                                        verticalAlign: 'top',
                                        fontSize: '13px',
                                        width: '15%'
                                    }}>&nbsp;</td>
                                    <td style={{
                                        border: '1px solid black',
                                        padding: '4px',
                                        textAlign: 'center',
                                        verticalAlign: 'top',
                                        fontSize: '13px',
                                        width: '8%'
                                    }}>&nbsp;</td>
                                    <td style={{
                                        border: '1px solid black',
                                        padding: '4px',
                                        textAlign: 'right',
                                        verticalAlign: 'top',
                                        fontSize: '13px',
                                        width: '17%'
                                    }}>&nbsp;</td>
                                    <td style={{
                                        border: '1px solid black',
                                        padding: '4px',
                                        textAlign: 'right',
                                        verticalAlign: 'top',
                                        fontSize: '13px',
                                        width: '15%'
                                    }}>&nbsp;</td>
                                </tr>
                            ))}
                            
                            {/* Rest of your table content remains the same */}
                            {isLastPage && (
                                <tr style={{ border: '1px solid black' }}>
                                    <td style={{
                                        border: '1px solid black',
                                        padding: '10px',
                                        textAlign: 'right',
                                        fontWeight: '700',
                                        fontSize: '14px'
                                    }}></td>
                                    <td
                                        colSpan={0}
                                        style={{
                                            fontSize: '13px',
                                            textAlign: 'left',
                                            fontStyle: 'italic',
                                            marginTop: '2px',
                                            color: '#222',
                                            borderTop: '1px dashed #aaa',
                                            paddingTop: '2px',
                                            border: '1px solid black'
                                        }}
                                    >
                                        <span
                                            style={{
                                                backgroundColor: '#f7eb9f',
                                                padding: '2px 4px',
                                                borderRadius: '3px',
                                            }}
                                        >
                                            Notes: {getValue(poData?.remarks)}
                                        </span>
                                    </td>
                                    <td style={{
                                        border: '1px solid black',
                                        padding: '10px',
                                        textAlign: 'right',
                                        fontWeight: '700',
                                        fontSize: '14px'
                                    }}></td>

                                    <td colSpan={0} style={{
                                        border: '1px solid black',
                                        padding: '10px',
                                        textAlign: 'right',
                                        fontWeight: '700',
                                        fontSize: '14px'
                                    }}>Total</td>
                                    <td style={{
                                        border: '1px solid black',
                                        padding: '10px',
                                        textAlign: 'right',
                                        fontWeight: '700',
                                        fontSize: '14px'
                                    }}></td>
                                    <td style={{
                                        border: '1px solid black',
                                        padding: '10px',
                                        textAlign: 'right',
                                        fontWeight: '700',
                                        fontSize: '14px'
                                    }}>{sum}</td>
                                </tr>
                            )}

                            {/* Total Rows - Only on last page */}
                            {isLastPage && (
                                <>
                                    <tr style={{ border: '1px solid black' }}>
                                        <td colSpan={6} style={{
                                            border: '1px solid black',
                                            padding: '8px',
                                            textAlign: 'left',
                                            fontWeight: '700',
                                            fontSize: '14px',
                                            textTransform: 'capitalize'
                                        }}>
                                            In Words: {sumInWords}
                                        </td>
                                    </tr>
                                </>
                            )}
                        </tbody>
                    </table>
                </div>

                {/* Footer - Only on last page */}
                {isLastPage && (
                    <div style={{
                        display: 'flex',
                        marginTop: '12px',
                        padding: '0 15px' // Add padding for footer
                    }}>
                        <div style={{ flex: '1.6', paddingRight: '12px' }}>
                            <div style={{ marginBottom: '12px', borderBottom: '1px solid black', paddingBottom: '10px' }}>
                                <div style={{ display: 'flex', alignItems: 'center', marginBottom: '6px' }}>
                                    <div style={{ minWidth: '120px', fontWeight: '600', fontSize: '14px' }}>GST</div>
                                    <span style={{ margin: '0 6px', fontWeight: '600' }}>:</span>
                                    <div style={{ fontSize: '14px', lineHeight: '1.3' }}>As Applicable</div>
                                </div>
                                <div style={{ display: 'flex', alignItems: 'center', marginBottom: '6px' }}>
                                    <div style={{ minWidth: '120px', fontWeight: '600', fontSize: '14px' }}>P & F Charges</div>
                                    <span style={{ margin: '0 6px', fontWeight: '600' }}>:</span>
                                    <div style={{ fontSize: '14px', lineHeight: '1.3' }}>{getValue(poData?.pandf, "NIL")}</div>
                                </div>
                                <div style={{ display: 'flex', alignItems: 'center', marginBottom: '6px' }}>
                                    <div style={{ minWidth: '120px', fontWeight: '600', fontSize: '14px' }}>Freight Charges</div>
                                    <span style={{ margin: '0 6px', fontWeight: '600' }}>:</span>
                                    <div style={{ fontSize: '14px', lineHeight: '1.3' }}>{getValue(poData?.freight, "NIL")}</div>
                                </div>
                                <div style={{ display: 'flex', alignItems: 'center', marginBottom: '6px' }}>
                                    <div style={{ minWidth: '120px', fontWeight: '600', fontSize: '14px' }}>Payment Terms</div>
                                    <span style={{ margin: '0 6px', fontWeight: '600' }}>:</span>
                                    <div style={{ fontSize: '14px', lineHeight: '1.3' }}>{getValue(poData?.paymentterms)}</div>
                                </div>
                                <div style={{ display: 'flex', alignItems: 'center', marginBottom: '6px' }}>
                                    <div style={{ minWidth: '120px', fontWeight: '600', fontSize: '14px' }}>Certificate</div>
                                    <span style={{ margin: '0 6px', fontWeight: '600' }}>:</span>
                                    <div style={{ fontSize: '14px', lineHeight: '1.3' }}>{getValue(poData?.certificate)}</div>
                                </div>
                                <div style={{ display: 'flex', alignItems: 'center', marginBottom: '6px' }}>
                                    <div style={{ minWidth: '120px', fontWeight: '600', fontSize: '14px' }}>Delivery Time</div>
                                    <span style={{ margin: '0 6px', fontWeight: '600' }}>:</span>
                                    <div style={{ fontSize: '14px', lineHeight: '1.3' }}>{getValue(poData?.deliverytime)}</div>
                                </div>
                            </div>

                            <div style={{ marginTop: '12px' }}>
                                <div style={{ fontSize: '14px', fontWeight: '600', marginBottom: '8px' }}>Delivery Address</div>
                                <div style={{ fontSize: '14px', lineHeight: '1.3', marginBottom: '6px', fontWeight: '600' }}>{getValue(poData?.branch?.company?.companyname)}</div>
                                <div style={{ display: 'flex', alignItems: 'flex-start', marginBottom: '6px' }}>
                                    <div style={{ minWidth: '50px', fontWeight: '600', fontSize: '14px' }}>Works</div>
                                    <span style={{ margin: '0 6px', fontWeight: '600' }}>:</span>
                                    <div style={{ fontSize: '14px', lineHeight: '1.3' }}>{getValue(poData?.warehouse?.address)}</div>
                                </div>
                                <div style={{ display: 'flex', alignItems: 'flex-start', marginBottom: '6px' }}>
                                    <div style={{ minWidth: '50px', fontWeight: '600', fontSize: '14px' }}>Dist</div>
                                    <span style={{ margin: '0 6px', fontWeight: '600' }}>:</span>
                                    <div style={{ fontSize: '14px', lineHeight: '1.3' }}>{getValue(poData?.warehouse?.city?.cityname)}</div>
                                </div>
                                <div style={{ display: 'flex', alignItems: 'flex-start', marginBottom: '6px' }}>
                                    <div style={{ minWidth: '50px', fontWeight: '600', fontSize: '14px' }}>State</div>
                                    <span style={{ margin: '0 6px', fontWeight: '600' }}>:</span>
                                    <div style={{ fontSize: '14px', lineHeight: '1.3' }}>{getValue(poData?.warehouse?.state?.statename)}</div>
                                </div>
                            </div>
                        </div>
                        <div style={{ flex: '1', borderLeft: '1px solid black', paddingLeft: '12px' }}>
                            <div style={{ marginTop: 0, marginBottom: '0.3rem', fontSize: '14px', lineHeight: '1.3' }}>For,</div>
                            <div style={{ padding: '0px 0px 100px 0px', fontWeight: '700', fontStyle: 'italic', fontSize: '16px' }}>SYNERGY Mechanics Pvt. Ltd.</div>
                            <div style={{ fontSize: '14px', fontWeight: '600', textAlign: 'center' }}>Authorised Signatory</div>
                        </div>
                    </div>
                )}

                {/* Page number */}
                <div style={{
                    position: 'absolute',
                    bottom: '12px',
                    right: '25px', // Increased right spacing
                    fontSize: '12px',
                    color: '#666'
                }}>
                    Page {pageNumber} of {totalPages}
                </div>
            </div>
        );
    };

    return (
        <>
            <style>
                {`
                    @media print {
                        body * {
                            visibility: hidden;
                        }
                        .print-section, .print-section * {
                            visibility: visible;
                        }
                        .print-section {
                            position: absolute;
                            left: 0;
                            top: 0;
                            width: 100%;
                            padding: 0;
                            margin: 0;
                        }
                        .no-print {
                            display: none !important;
                        }
                        .page {
                            page-break-after: always;
                            border: 1px solid black !important;
                            margin: 0 auto !important;
                        }
                        .page:last-child {
                            page-break-after: auto;
                        }
                        @page {
                            margin: 1cm;
                            size: A4;
                        }
                    }
                `}
            </style>

            <div className="no-print" style={{
                display: 'flex',
                gap: '10px',
                justifyContent: 'center',
                marginBottom: '16px',
                padding: '12px'
            }}>
                <button className="btn btn-secondary" onClick={() => navigate(-1)} style={{ fontSize: '14px', padding: '8px 16px' }}>
                    ← Back
                </button>
                <button className="btn btn-primary" onClick={handlePrint} style={{ fontSize: '14px', padding: '8px 16px' }}>
                    🖨️ Print Purchase Order
                </button>
            </div>

            <div ref={printRef} className="print-section">
                {Array.from({ length: totalPages }, (_, i) => renderPage(i + 1))}
            </div>
        </>
    );
};

export default PoDomPrint;